import React, { useState } from "react";
import RoundedButton from "../../../Buttons/RoundedButton";
import { useTranslation } from "react-i18next";
import * as buttonsConf from "../../../../constants/buttons";
import TagInputSignUp from "../../../UI/Inputs/TagInputSignUp";
import { useNavigate } from "react-router-dom";
import iconInformation from "../../../../assets/images/icon_information.svg";
import { R_REGISTER_SUCCESS } from "../../../../constants/routes";
import { Box, Button, Typography } from "@mui/material";

const Verification = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [showTextError, setShowTextError] = useState(false);

  // Determinar se temos um erro de "código já utilizado" mas o usuário ainda está vinculado com sucesso
  const isCodeUsedButLinked =
    props.verifyError &&
    props.verifyError.includes("Invalid code provided") &&
    props.isLinkedSuccessfully;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        gap: 3,
      }}
    >
      <Box sx={{ mt: 2 }}>
        <Typography
          sx={{
            color: "#4d4d4d",
            fontSize: { xs: "16px", md: "18px" },
            fontStyle: "normal",
            fontWeight: 400,
          }}
        >
          {t(
            "global.to_verify_your_account_we_will_send_a_verification_code_to_your_email_enter_your_code_in_the_field_below_to_complete_your_registration",
          )}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: 2,
          borderRadius: "2px",
          border: "2px solid #5F30E2",
          background: "#fff",
          mt: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: "20px",
                height: "20px",
              }}
            >
              <img src={iconInformation} alt={t("global.icon_information")} />
            </Box>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                color: "#28293D",
                fontWeight: 700,
              }}
            >
              {t("global.important_do_not_close_this_page")}
            </Typography>
          </Box>
          <Box sx={{ marginLeft: { xs: "0px", sm: "28px" } }}>
            <Typography
              sx={{
                fontSize: { xs: "14px", md: "16px" },
                color: "#4d4d4d",
                fontWeight: 300,
              }}
            >
              {t(
                "global.keep_this_page_open_to_enter_the_verification_code_we_sent_to_your_email",
              )}
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box sx={{ width: { xs: "280px", sm: "300px" } }}>
        <TagInputSignUp
          type="text"
          name="verify_codigo"
          label={t("global.verify_code")}
          placeholder={t("global.verify_code")}
          value={props.signUpForm.verify_codigo}
          onChange={props.onChange}
          errorButton={true}
          showTextError={
            props.verifyError !== "" || props.codeResend ? true : false
          }
          textError={
            props.codeResend
              ? "verifique seu email!"
              : props.verifyError.replace(/ /g, "_") ===
                  "Invalid_code_provided,_please_request_a_code_again."
                ? t(`global.${props.verifyError.replace(/ /g, "_")}`)
                : t(`global.${props.verifyError.replace(/\./g, "")}`)
          }
          required
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          <Typography
            sx={{ fontSize: "16px", color: "#4d4d4d", marginLeft: "8px" }}
          >
            {t("global.dindnt_receive_your_code")}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ color: "red", marginLeft: "8px" }}>
            {props.resentCodeSuccess && props.resentCodeSuccess}
          </Typography>
        </Box>
        <Box>
          <Typography sx={{ color: "red", marginLeft: "8px" }}>
            {props.resentCodeError && props.resentCodeError}
          </Typography>
        </Box>

        <Box>
          <Button
            onClick={(e) => props.resendCode(e)}
            sx={{
              color: "#662D91",
              fontSize: { xs: "12px", sm: "14px" },
              fontWeight: 600,
              textTransform: "none",
              "&:hover": {
                backgroundColor: "transparent",
                textDecoration: "underline",
              },
            }}
          >
            {t("global.click_here_to_send_it_to_us_again")}
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <RoundedButton
          sx={{ width: "240px" }}
          text={
            isCodeUsedButLinked
              ? t("global.go_to_dashboard")
              : t("global.finalize_registration")
          }
          size={buttonsConf.BTN_SIZE_MD}
          onClick={async () => {
            if (isCodeUsedButLinked) {
              // Redirecionar para o painel de cadastro com sucesso, se vinculado com sucesso
              props.redirectToRegister
                ? props.redirectToRegister()
                : navigate(R_REGISTER_SUCCESS);
              console.log("Entrou no if do cadastro");
            } else {
              setShowTextError(true);
              // const success = await props.formSubmit();
              props.setCodeResend(false);
              console.log("Entrou no else do cadastro");

              try {
                const success = await props.formSubmit();
                if (success) {
                  props.redirectToDashboard();
                }
              } catch (error) {
                console.log("erro no cadastro", error);
              }
            }
          }}
        />
      </Box>
    </Box>
  );
};
export default Verification;
